module.exports = __webpack_public_path__ + "img/kremer-express.74a73cce.png";